import ExcelSheet from "../SvgIcons/ExcelSheet";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

import { formatCountryDate } from "../../Services/countryTime";
export default function ExcelDownloadButton({ data = [] }) {
  const handleDownload = async () => {
    try {
      if (!data.length) {
        await Swal.fire({
          icon: "warning",
          title: "Notice",
          text: "No data available to download.",
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EventRegistrations");

      // -------------------
      // Column headers (dynamic)
      // -------------------
      const headers = [
        "Sr.No.",
        "Name",
        "Email",
        "Mobile No.",
        "Organization Name",
        "Tally Number",
        "Confirmation By",
        "Participants",
        "Registration Date",
        "Mode of Meeting",
      ];

      const columnWidths = [7, 28, 37, 14, 40, 13, 15, 12, 17, 17];
      worksheet.columns = headers.map((h, i) => ({ header: h, key: h, width: columnWidths[i] }));

      const totalColumns = worksheet.columns.length;
   
      // -------------------
      // Main Title row
      // -------------------
      worksheet.mergeCells(`A1:${String.fromCharCode(64 + totalColumns)}1`);
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "Event Registrations";
      titleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      titleCell.font = { bold: true, size: 14, color: { argb: "FFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "38598e" } };
      worksheet.getRow(1).height = 30;

      // -------------------
      // Format helpers
      // -------------------
      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return formatCountryDate(d).replace(/\//g, "-");
      };

      const formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [hour, minute] = timeStr.split(":");
        const date = new Date();
        date.setHours(hour, minute);
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
      };

      // -------------------
      // Group data by event title + date + time
      // -------------------
      const grouped = data.reduce((acc, item) => {
        const groupKey = `${item.Title} - ${formatDate(item.event_date)} - (${formatTime(item.StartTime)} to ${formatTime(item.EndTime)})`;
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(item);
        return acc;
      }, {});

      let currentRow = 2;

      for (const [eventTitle, records] of Object.entries(grouped)) {
        // Event Title row
        worksheet.mergeCells(`A${currentRow}:${String.fromCharCode(64 + totalColumns)}${currentRow}`);
        const eventCell = worksheet.getCell(`A${currentRow}`);
        eventCell.value = eventTitle;
        eventCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        eventCell.font = { bold: true, size: 12, color: { argb: "000000" } };
        eventCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "cce5ff" } };
        worksheet.getRow(currentRow).height = 25;

        currentRow++;

        // Header row
      const headerRow = worksheet.addRow(headers);
        headerRow.eachCell((cell, colNumber) => {
            const leftAlignHeaders = ["Name", "Email", "Organization Name", "Confirmation By"];
            const headerValue = headers[colNumber - 1]; // get header text by index
            cell.alignment = leftAlignHeaders.includes(headerValue)
                ? { horizontal: "left", vertical: "middle", wrapText: true }
                : { horizontal: "center", vertical: "middle", wrapText: true };
            cell.font = { bold: true, color: { argb: "000000" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "e5ebf5" } };
        });
        worksheet.getRow(headerRow.number).height = 25;
        // Data rows
        records.forEach((item, index) => {
          const row = worksheet.addRow([
            index + 1,
            item.name,
            item.email,
            item.mobile,
            item.organization,
            item.tallynumber,
            item.confirmation,
            item.NoOfParticipants,
            formatDate(item.registration_date),
            item.ModeOfMeeting,
          ]);

          row.height = 20;

             const leftAlignHeaders = ["Name", "Email", "Organization Name", "Confirmation By"];
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                const headerValue = headers[colNumber - 1]; // get header text by index
                cell.alignment = leftAlignHeaders.includes(headerValue)
                    ? { horizontal: "left", vertical: "middle", wrapText: true }
                    : { horizontal: "center", vertical: "middle", wrapText: true };
            });
        });

        currentRow = worksheet.lastRow.number + 2; // space after event
      }

      // -------------------
      // Borders
      // -------------------
      worksheet.eachRow((row) => {
        for (let col = 1; col <= totalColumns; col++) {
          const cell = row.getCell(col);
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        }
      });

      // -------------------
      // Export Excel
      // -------------------
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Event_Registrations.xlsx");
    } catch (error) {
      console.error("Error while downloading Excel:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to download Excel.",
      });
    }
  };

  return (
    <button type="button" className="btn btn-purpal addbutton" onClick={handleDownload}>
      <ExcelSheet /> Excel
    </button>
  );
}
